export const jitsiToken = 'vpaas-magic-cookie-df443494c03c49dbbfcf92008e5478e0';
export const jitsiSecretKey = 'OvufWd1OgCz4VnWikrxcUV9Yc'
export const extractDebtsAgilis = 'https://agilisdivida.pgm.fortaleza.ce.gov.br'
